import { PaymentOptionModel } from '@modules/payment-option/payment-option-model';

const { fields } = PaymentOptionModel;

export default [
  fields.id,
  fields.type,
  fields.status,
  fields.numberOfPayments,
  fields.createdAt,
  fields.updatedAt
];
